<template>
	<section class="faq-section align-center">
		<div v-for="faq in items" :key="faq.ID" class="row faq">
			<div class="columns column12 align-center">
				<h3>{{ faq.header }}</h3>
				<div class="collapse-container">
					<collapse
						v-for="item in faq.faqitems"
						:key="item.ID"
						:header="item.question"
						:content="item.answer"
					/>
				</div>
			</div>
		</div>
	</section>
</template>

<script setup>
defineProps({
	header: { type: String, default: '' },
	items: { type: Array, default: () => [] },
});
</script>

<style lang="scss" scoped>
.faq-section {
	text-align: left;
	padding: 25px 0 50px;

	.row {
		max-width: 860px;
		margin: 10px auto 30px;
	}

	h3 {
		margin-bottom: 20px;
		font-size: 1.7em;
		max-width: 380px;
		color: var(--dark-background-color);
	}
}
</style>
